import _toConsumableArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
import { Box, ContentPlaceHolderPresetLineBlock } from "@catchoftheday/cg-components";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var SavedPaymentMethodsPlaceholder = function SavedPaymentMethodsPlaceholder(_ref) {
  var rows = _ref.rows;
  return ___EmotionJSX(Box, {
    display: "grid",
    rowGap: 6
  }, _toConsumableArray(Array(rows)).map(function (_, idx) {
    return ___EmotionJSX(ContentPlaceHolderPresetLineBlock, {
      key: idx,
      height: "40px",
      width: "480px",
      borderRadius: "8px"
    });
  }));
};